import React from 'react';
import { Box, Modal, Button, useTheme, Typography, IconButton } from "@mui/material";
import { tokens } from "../theme";
import { DataGrid } from "@mui/x-data-grid";
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as XLSX from 'xlsx';

const ModalBancoHoras = ({ open, onClose, data }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [
    { field: "fecha", headerName: "Fecha", flex: 1 },
    { field: "horas_texto", headerName: "Horas Banco", flex: 1 },
    { field: "estado", headerName: "Estado", flex: 1 },
  ];

  const handleExportToExcel = () => {
    if (!data || !data.detalle) return;

    const workbook = XLSX.utils.book_new();

    const exportData = data.detalle.map(item => ({
      Fecha: item.fecha,
      Horas: item.horas_texto,
      Estado: item.estado,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Banco de Horas");
    XLSX.writeFile(workbook, `Banco_Horas_${data.nombre.replace(/\s+/g, '_')}.xlsx`);
  };

  if (!data) return null;

  // Sumamos en HORAS (no minutos) y mostramos en H:mm
  const totalHorasValor = data.detalle.reduce((acc, curr) => acc + (curr.horas_h || 0), 0);
  const totalHorasEnteras = Math.floor(totalHorasValor);
  const totalMins = Math.round((totalHorasValor - totalHorasEnteras) * 60);

return (
    <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-banco-horas"
        aria-describedby="modal-descripcion-banco-horas"
    >
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '80%',
                maxWidth: 1000,
                bgcolor: colors.primary[400],
                borderRadius: '8px',
                boxShadow: 24,
                p: 4,
            }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h5" component="h2">
                    Banco de Horas - {data.nombre}
                </Typography>
                <Box>
                    <IconButton 
                        onClick={handleExportToExcel}
                        sx={{ marginRight: 1, color: colors.greenAccent[500] }}
                    >
                        <FileDownloadIcon />
                    </IconButton>
                    <IconButton 
                        onClick={onClose}
                        sx={{ color: colors.grey[500] }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
            </Box>

            <Box mb={2}>
                <Typography variant="subtitle1">
                    Grupo: {data.grupo}
                </Typography>
                <Typography variant="subtitle1">
                    Total Horas en Banco: {totalHorasEnteras}:{totalMins.toString().padStart(2, '0')}
                </Typography>
            </Box>

            <Box height="400px">
                {data.detalle && data.detalle.length > 0 ? (
                    <DataGrid
                        rows={data.detalle}
                        columns={columns}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        disableSelectionOnClick
                        getRowId={(row) => row.id || Math.random().toString()}
                        sx={{ fontSize: '1rem' }}
                    />
                ) : (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                        <Typography variant="h6" color={colors.grey[300]}>
                            Sin registros en el banco de horas
                        </Typography>
                    </Box>
                )}
            </Box>
            <Box mt={2} p={4} bgcolor={colors.blueAccent[800]} borderRadius="4px">
                <Typography variant="body1" color={colors.grey[100]}>
                    <strong>Nota:</strong> El registro, seguimiento y descuento de las horas del banco de horas son responsabilidad exclusiva del departamento de Recursos Humanos. Para cualquier consulta o solicitud de uso de horas acumuladas, dirigirse a RRHH.
                </Typography>
            </Box>
        </Box>
    </Modal>
);
};

export default ModalBancoHoras;